import React, {FunctionComponent, useState} from "react";
import NiceModal, {NiceModalHocProps, useModal} from "@ebay/nice-modal-react";
import {ICustomPaymentPlanViewProps} from "../../utils";
import ChooseInstallmentsAmount from "./ChooseInstallmentsAmount";
import {IPlanMatrix} from "../../../../../../../declerations/server/payment_plan_models";
import {CloseDialogButton, Container, FormControlLabel, LoadingCenter, Text} from "@bounce/shared/ui";
import {useTask, useUserMetaData} from "../../../../../../../contexts";
import {useGetUserWithSelectedAccountQuery} from "../../../../../../../apis/requests/backoffice";
import {Dialog, Switch, useMediaQuery} from "@mui/material";

export const PlanBuilderDialog: FunctionComponent<ICustomPaymentPlanViewProps & NiceModalHocProps> = NiceModal.create(
  () => {
    const [isSupervisorView, setIsSupervisorView] = useState(false);
    const [selectedPlan, setSelectedPlan] = React.useState<IPlanMatrix | null>(null);
    const [resetSelectedPlan, setResetSelectedPlan] = useState(true);
    const {accountId} = useUserMetaData();
    const {userId} = useTask();
    const isNarrowScreen = useMediaQuery("(max-width:1200px)");
    const {data: user} = useGetUserWithSelectedAccountQuery({userId, accountId}, {enabled: !!userId});
    const modal = useModal();

    const handleClose = async () => {
      modal.resolve(false);
      modal.hide();
    };

    if (!user) {
      return <LoadingCenter />;
    }
    return (
      <Dialog
        fullScreen={true}
        open={modal.visible}
        onClose={handleClose}
        sx={{
          margin: isNarrowScreen ? "5% 2%" : "5% 20%",
          "& .MuiPaper-root": {
            alignItems: "center",
            borderRadius: "16px",
            padding: "44px",
            gap: "24px",
          },
        }}
      >
        <CloseDialogButton onClose={modal.hide} />
        <Container fullWidth row sx={{justifyContent: "space-between", height: "40px", width: "690px"}}>
          <Text size={20} variant={"interDisplay600"}>
            Plans Preview
          </Text>
          <FormControlLabel
            control={
              <Switch
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setIsSupervisorView?.(event.target.checked);
                }}
              />
            }
            checked={isSupervisorView}
            label="Restricted options"
            style={{whiteSpace: "nowrap"}}
          />
        </Container>
        <ChooseInstallmentsAmount
          handleNext={() => setResetSelectedPlan(false)}
          userBalance={user.account}
          isSupervisorView={isSupervisorView}
          selectedPlan={selectedPlan}
          setSelectedPlan={setSelectedPlan}
          resetSelectedPlan={resetSelectedPlan}
          setResetSelectedPlan={setResetSelectedPlan}
          isPreview
        />
      </Dialog>
    );
  }
);
